import React from 'react';
import { StorefrontStylingData } from '../../../api';
import { OrderPageProvider } from '../../../orderPage/orderPageContext/OrderPageProvider';
import OrderPage from '../../../orderPage/OrderPage';

type BookingWidgetWrapperProps = {
  storefrontStyling?: StorefrontStylingData;
  Provider?: React.ComponentType<{ children: React.ReactNode; storefrontTheme: any }>;
  orderPageIdOverride?: string;
  startsMonetaryGiftCard?: boolean;
};

export const BookingWidgetWrapper = ({
  storefrontStyling,
  Provider = OrderPageProvider,
  orderPageIdOverride,
  startsMonetaryGiftCard,
}: BookingWidgetWrapperProps) => {
  const storefrontTheme = storefrontStyling
    ? {
        palette: {
          primary: storefrontStyling.button_color || '#16854C',
          background: '#ffffff',
        },
        typography: {
          fontFamily: 'Assistant, Roboto, sans-serif',
        },
      }
    : undefined;

  if (startsMonetaryGiftCard) {
    return (
      <OrderPageProvider
        storefrontTheme={storefrontTheme}
        orderPageIdOverride={orderPageIdOverride}
        startsMonetaryGiftCard>
        <OrderPage storefrontMode />
      </OrderPageProvider>
    );
  }

  return (
    <Provider storefrontTheme={storefrontTheme}>
      <OrderPage storefrontMode />
    </Provider>
  );
};
